import React from 'react'
import ButtonUi from './../../UiElements/Button'

const Button = ({ item, value, handleChange, onClick, children, pending, formData }) => {
  const disabled = typeof item.disabled === 'function' ? item.disabled(formData) : item.disabled || false

  return (
    <ButtonUi
      className={item.className}
      icon={item.icon}
      size={item.size}
      type={item.buttonType}
      disabled={disabled}
      iconPosition={item.iconPosition}
      onClick={() => {
        if (value) {
          value(item, formData)
        }
      }}
    >
      {item.label}
    </ButtonUi>
  )
}

export default Button
